import { IProductMatch } from 'shared/interfaces'
import { TNotifications } from '../types'

export const formatMatchSearch = ({ id, notification_type, product, properties }: TNotifications): IProductMatch => ({
  id: id ?? '',
  name: product?.name ?? '',
  artistId: product?.campaign?.artist?.id ?? '',
  configuration: product?.configuration ?? '',
  parent_id: product?.parent_id ?? '',
  notification_type: notification_type ?? '',
  matches: properties?.gcdm_matches ?? []
})